
export const sFechaPublicacion = '2026-06-24T14:54:02.1703819-06:00';
export const sVersion = 'vf1.1.606241454';
            